import axios from 'axios'

class RecallService {

  async getRecalls(saleId) {
    return await axios.get(`/api/sale/recalls/${saleId}`);
  }

  async getRecall(recallId) {
    return await axios.get(`/api/recall/${recallId}`);
  }

  async addRecall(payload) {
    return await axios.post('/api/recall', payload);
  }

  async updateRecall(id, payload) {
    return await axios.post(`/api/recall/${id}`, payload);
  }

  async deleteRecall(id) {
    return await axios.get(`/api/recall/remove/${id}`);
  }
}

export default RecallService;